import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AuthenticationService, NotificationService, TxMsgService, TxKeywordService} from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TxKeyword } from 'src/app/_models';

@Component({templateUrl: './msg-list.component.html' })
export class KwMsgListComponent implements OnInit {
  keyword: TxKeyword = null;
  newMsgForm: FormGroup;
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;
  msgList: [];
  filterable = {
    kid: ''
  };


  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authSvc: AuthenticationService,
    private txMsgSvc: TxMsgService,
    private txKeywordSvc: TxKeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.filterable.kid = id;
    this.loadKeyword(id);
    this.loadPage(1);
  }

  loadKeyword(id){
    this.txKeywordSvc.getKeyword(id).subscribe(data => {
      this.keyword = data
    });
  }

  openModal(targetModal) {
    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newMsgForm = this.fb.group({
      lang: ['', Validators.required],
      subscribeSuccessMsg: [''],
      subscribeAlreadyMsg: [''],
      subscribeFailedMsg: [''],
      subscribeChargeSuccessMsg: [''],
      subscribeChargeSuccessUrl: [''],
      subscribeLowBalanceMsg: [''],
      renewalReminderMsg: [''],
      renewalSuccessMsg: [''],
      renewalSuccessUrl: [''],
      renewalLowBalanceMsg: [''],
      unsubscribeSuccessMsg: [''],
      unsubscribeAlreadyMsg: [''],
      mtContent: [''],
      mtContentUrl: [''],
    });
  }

  get f() { return this.newMsgForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  back() {
    this.router.navigate(['/dashboard/tx/keyword']);
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  deleteMsg(id){
    if (confirm("Are you sure to delete this template?")) {
      this.txMsgSvc.deleteKwMsg(id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Template deleted successfully!", "Delete Template");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting template, please try again later.", "Error");
        }
      })
    }
  }
  onSubmit() {
    this.processing = true;
    var newDataParam = this.newMsgForm.getRawValue();
    newDataParam.kid = this.filterable.kid;
    if (this.newMsgForm.valid) {
      if (confirm("Are you sure to add the template now?")) {
        this.txMsgSvc.addKwMsg(newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Template added successfully!", "New Template");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add template, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.msgList = [];
    let params = this.formParam(page);

    // get page of items from api
    this.txMsgSvc.getKwMsgAll(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.msgList = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      kid: this.filterable.kid
    }
    console.log(params)
    return params;
  }

}
